// ** internal, non-publicly exported constants. **
export var FlowDirection = {
  BACK: 'back',
  NONE: 'none',
  FORWARD: 'forward'
}; // Requests that are blocked by the Anti-Fraud Service return a 454 status and `decision` (reason)

export var AntiFraudDecision = {
  REQUIRES_PHONE_VERIFICATION: 'REQUIRES_PHONE_VERIFICATION',
  DENY: 'DENY'
};
export var FlexEventTypes = {
  BETA_APP_VIEW_EVENT: 'BETA_APP_VIEW_EVENT',
  BETA_INTERACTION_EVENT: 'BETA_INTERACTION_EVENT',
  BETA_INPUT_FLOW_EVENT: 'BETA_INPUT_FLOW_EVENT'
};
export var FlexApplicationEventNames = {
  EMAIL_VERIFICATION: 'EmailVerification',
  EMAIL_VERIFICATION_SENT: 'EmailVerificationSent',
  EMAIL_VERIFICATION_SUCCESS: 'EmailVerificationSuccess',
  LETS_GET_STARTED: 'LetsGetStarted',
  ONBOARDING_COMPLETE: 'OnboardingComplete',
  VERIFY_PERSONAL_INFO: 'VerifyPersonalInfo',
  USER_SSN: 'UserSSN',
  FULL_SNN: 'FullSSN',
  VERIFICATION_RETRY: 'VerificationRetry',
  CHECK_FOR_TYPOS: 'CheckForTypos',
  KYC_VERIFICATION_FAILED: 'KYCVerificationFailed',
  ADD_PHONE_NUMBER: 'AddPhoneNumber',
  SMS_CODE_VERIFICATION: 'SmsCodeVerification'
};
export var FLEX_MONEY_TRANSFER_APPLICATION_NAME = 'MoneyTransfer';
export var AppleAuthErrors = {
  POPUP_CLOSED_BY_USER: 'POPUP_CLOSED_BY_USER',
  CROSS_ORIGIN_POST_MESSAGE: 'CROSS_ORIGIN_POST_MESSAGE',
  STATE_PARAM_MISMATCH: 'STATE_PARAM_MISMATCH'
};
/**
 * Possible reasons the last 3rd party (Google or Apple) auth action failed. Used for legacy flows.
 * If it's not a reason we care about then it falls to `OTHER`
 */

export var ThirdPartyAuthFailReasons = {
  REQUIRES_PASSWORD: 'requires_password',
  OTHER: 'other'
};